import styled, { css } from "styled-components"
import { rem } from "polished"
import { breakpoints } from "@config/theme"

export const Item = styled.button<{ active?: boolean }>`
  height: 100%;
  cursor: pointer;
  border: none;
  padding: 0;
  outline: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  text-align: center;
  outline: none;
  align-items: center;
  justify-content: flex-end;
  opacity: 1;
  width: 100%;
  opacity: 0.3;
  margin-top: -1rem;
  transition: all 0.3s ease-in-out;
  position: relative;
  ${(p) =>
    p.active &&
    css`
      opacity: 1;
    `}
`

export const Img = styled.img`
  width: 100%;
  max-width: 100px;
  top: 0;
  left: 0;
  object-fit: contain;
  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }

  @media screen and (max-width: 320px) {
    max-width: 4rem;
  }
`

export const Details = styled.div`
  text-align: center;
  max-width: 80%;
  display: block;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: black;
  font-size: ${rem("12px")};

  span {
    display: block;
    margin-top: 0.5rem;
  }
`

export const NavButtons = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  height: calc(52% - 7rem);
  top: 6rem;
  position: fixed;
  justify-content: space-between;

  @media screen and (max-width: 320px) {
    height: calc(45% - 7rem);
  }

  @media screen and (min-width: ${breakpoints.small}) {
    height: calc(65% - 7rem);
    top: 10rem;
  }
`

export const NavButton = styled.button`
  background: transparent;
  padding: 0;
  border: 0;
  outline: 0;
  padding: 1rem;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${(p) => p.theme.colors.text.light};
  }
`
